import { Link } from "react-router-dom";

export default function ProfileItem({ userType }) {
  // Handles WhatsApp sharing for app links
  const handleShareClick = () => {
    const message = `
Welcome to ${window.APP_NAME} 🎉

🌐 Website: ${window.WEBSITE_LINK}
📱 Android App: ${window.APP_DOWNLOAD_LINK}
🍎 iOS App: ${window.APP_LINK_IOS}
💻 Desktop App: ${window.APP_LINK}
    `.trim();

    const encodedText = encodeURIComponent(message);
    const whatsappUrl = `whatsapp://send?text=${encodedText}`;

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      window.location.href = whatsappUrl;
    } else {
      window.open(
        `https://web.whatsapp.com/send?text=${encodedText}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  const getSafeLocalStorageJSON = (key, fallback = {}) => {
    try {
      const value = localStorage.getItem(key);
      if (!value || value === "undefined") return fallback;
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  };

  const userdata = getSafeLocalStorageJSON("userdata");
  const nse_cash = Number(userdata?.nse_cash || 0);

  // Returns settlement path based on user type
  const getSettlementPath = () => {
    switch (userType) {
      case 1:
        return "/SettlementAdmin";
      case 2:
        return "/SettlementSuper";
      case 3:
        return "/SettlementMaster";
      case 4:
        return "/SettlementUser";
      default:
        return null;
    }
  };

  // Menu item configuration
  const items = [
    (userType === 1 || userType === 2 || userType === 3 || userType === 4) && {
      label: "SETTLEMENT",
      path: getSettlementPath(),
    },
    { label: "LEDGER", path: "/Ledger" },
    { label: "RULES", path: "/Rules" },
    userType === 4 && { label: "SYMBOL LOGS", path: "/SymbolLogs" },
    { label: "LOGIN LOGS", path: "/LoginLogs" },
    { label: "SYMBOL QUANTITY", path: "/SymbolQty" },
    { label: "CHANGE PASSWORD", path: "/ChangePassword" },
    (userType === 4 && nse_cash === 1) && { label: "INTEREST BILL", path: "/InterestBill" },
    userType === 4 && { label: "GENERATE BILL", path: "/GenerateBill" },
    userType !== 4 && { label: "GENERATE BILL", path: "/GenerateBillAll" },
    { label: "MESSAGE", path: "/Message" },
    { label: "INVITE FRIENDS", onClick: handleShareClick },
    { label: "PROFILE", path: "/Profile" },
    userType === 1 && { label: "SYMBOL", path: "/Symbol" },
  ].filter(Boolean); // removes falsy (null) items

  return (
    <div className="StandingContainer">
      {items.map((item, index) => {
        const borderClass =
          index !== items.length - 1 ? "AddBorderStanding" : "";

        const content = (
          <div
            className={`StandingText ${borderClass}`}
            style={item.onClick ? { cursor: "pointer" } : undefined}
          >
            {item.label}
          </div>
        );

        return item.path ? (
          <Link
            key={item.label}
            to={item.path}
            className="large unselectlink"
            aria-label={item.label}
          >
            {content}
          </Link>
        ) : (
          <div key={item.label} onClick={item.onClick}>
            {content}
          </div>
        );
      })}
    </div>
  );
}
